import React from "react";
import SVGIcon from "web/react/components/svg-icon/svg-icon";
import { gettext } from "web/script/modules/django-i18n";
import styles from "./taxonomy-links.module.css";

interface TaxonomyLink {
    url: string;
    taxonomy: string;
}

interface GenderTaxonomyLinks {
    F?: TaxonomyLink[];
    M?: TaxonomyLink[];
}

interface TaxonomyLinksProps {
    genderTaxonomyLinks: GenderTaxonomyLinks[];
    brandName: string;
}
export default function TaxonomyLinksComponent({
    genderTaxonomyLinks,
    brandName,
}: TaxonomyLinksProps): JSX.Element {
    function getTaxonomy(genderKey, designer, category): string {
        const gender = genderKey === "F" ? gettext("general.womens") : gettext("general.mens");
        return gettext("feed.designer_for_gender.results.title", {
            for_gender: gender,
            designer_name: designer,
            category_name: category,
        });
    }

    function getLinkList(gender, links): JSX.Element {
        return links.map((link) => (
            <li key={link.taxonomy}>
                <a href={link.url}>{getTaxonomy(gender, brandName, link.taxonomy)}</a>
                <SVGIcon name="chevron" />
            </li>
        ));
    }

    function getCategoryTitle(designerName, genderKey): string {
        if (genderKey === "M") {
            return gettext("feed.designer_for_men.title", {
                designer_name: designerName,
            });
        } else {
            return gettext("feed.designer_for_women.title", {
                designer_name: designerName,
            });
        }
    }

    function getCategory(category): JSX.Element {
        const categoryKey = Object.keys(category)[0];
        if (category[categoryKey]?.length) {
            return (
                <>
                    <p className={styles.categoryTitle}>
                        {getCategoryTitle(brandName, categoryKey)}
                    </p>
                    <ul className={styles.linkList}>
                        {getLinkList(categoryKey, category[categoryKey])}
                    </ul>
                </>
            );
        }

        return <></>;
    }

    return (
        <div className={styles.taxonomyLinks}>
            {genderTaxonomyLinks.map((category, index) => (
                <div key={index} className={styles.category}>
                    {getCategory(category)}
                </div>
            ))}
        </div>
    );
}
